import { FunctionComponent } from 'react'

import { Box, Flex } from '@theme-ui/components'

import { baseColors } from '@fairhq/common'
import { PermissionsEnum, useAuthPermissions } from 'hooks/useAuthPermissions'
import { useAuthRoles } from 'hooks/useAuthRoles'
import { useGetEntitlementsQuery } from 'store/company/companyApiWithQuery'
import { EntitlementsEnum } from 'store/company/types'

import RouterLink from 'ui-kit/RouterLink'

import { CharlieLogoInverse } from './assets/CharlieLogoInverse'
import { BottomMenu } from './BottomMenu'
import { MenuGroupAdmin } from './MenuGroupAdmin'
import { MenuGroupAssessment } from './MenuGroupAssessment'
import { MenuGroupDiversity } from './MenuGroupDiversity'
import { MenuGroupEquality } from './MenuGroupEquality'
import { MenuGroupExperience } from './MenuGroupExperience'
import { MenuGroupStrategy } from './MenuGroupStrategy'
import { MenuGroupSurvey } from './MenuGroupSurvey'

export const Sidebar: FunctionComponent = () => {
  const { data: companyEntitlements } = useGetEntitlementsQuery()
  const { permissions } = useAuthPermissions()
  const { isAdmin } = useAuthRoles()

  // Sidebar items follow an specific business order
  return (
    <Flex
      sx={{
        width: '185px',
        minHeight: '100%',
        bg: baseColors.frameBackground,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ flexBasis: '100%' }}>
        <RouterLink to="/" sx={{ display: 'block', p: '16px' }}>
          <CharlieLogoInverse />
        </RouterLink>

        {isAdmin && <MenuGroupAdmin />}

        {permissions?.includes(PermissionsEnum.READ_SURVEYWINDOW) &&
          companyEntitlements?.entitlements.includes(
            EntitlementsEnum.SURVEYS
          ) && <MenuGroupSurvey />}

        {companyEntitlements?.entitlements.includes(
          EntitlementsEnum.ADVANCED_ASSESSMENT_AUDIT
        ) &&
          permissions?.includes(PermissionsEnum.READ_ASSESSMENT) && (
            <MenuGroupAssessment />
          )}

        {(companyEntitlements?.entitlements.includes(
          EntitlementsEnum.ADVANCED_ASSESSMENT_AUDIT
        ) ||
          companyEntitlements?.entitlements.includes(
            EntitlementsEnum.ADVANCED_ASSESSMENT_AUDIT
          )) &&
          permissions?.includes(PermissionsEnum.READ_REPORTS) && (
            <MenuGroupEquality />
          )}

        {companyEntitlements?.entitlements.includes(EntitlementsEnum.DEM) &&
          permissions?.includes(PermissionsEnum.READ_REPORTS) && (
            <MenuGroupDiversity />
          )}

        {(companyEntitlements?.entitlements.includes(EntitlementsEnum.IS) ||
          companyEntitlements?.entitlements.includes(EntitlementsEnum.PP)) &&
          permissions?.includes(PermissionsEnum.READ_REPORTS) && (
            <MenuGroupExperience />
          )}

        {companyEntitlements?.entitlements.includes(
          EntitlementsEnum.STRATEGY
        ) &&
          permissions?.includes(PermissionsEnum.READ_REPORTS) && (
            <MenuGroupStrategy />
          )}
      </Box>

      <BottomMenu />
    </Flex>
  )
}
